import { render, staticRenderFns } from "./IgOpenTicketPopup.vue?vue&type=template&id=12ddb84c&scoped=true&"
import script from "./IgOpenTicketPopup.vue?vue&type=script&lang=js&"
export * from "./IgOpenTicketPopup.vue?vue&type=script&lang=js&"
import style0 from "./IgOpenTicketPopup.vue?vue&type=style&index=0&id=12ddb84c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ddb84c",
  null
  
)

export default component.exports